/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Link CSS
 */
export const styles = css`
  :host {
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    user-select: none;
    white-space: nowrap;
    padding: var(--nile-spacing-lg, var(--ng-spacing-lg));
    gap: var(--nile-spacing-md, var(--ng-spacing-xs));
    height: 38px;
    box-sizing: border-box;
    cursor: pointer;
    text-decoration:none;
  }

  .link__label {
    color: var(--nile-colors-primary-600, var(--ng-colors-text-brand-secondary-700));
    text-align: center;
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
    font-style: normal;
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-semibold));
    line-height: var(--nile-line-height-xsmall, var(--ng-line-height-text-sm));
    letter-spacing: 0.2px;
  }

  .link--disabled {
    color: var(--nile-colors-primary-500, var(--ng-colors-text-tertiary-600));
    pointer-events: none;
  }
  :host([disabled]) {
    cursor: not-allowed;
  }

  .link.link--disabled:not(.link__button) .link__label {
    color: var(--nile-colors-primary-500, var(--ng-colors-fg-disabled));
  }

  
  .link:not(.link--disabled):not(.link__button):hover ,
  .link:not(.link--disabled):not(.link__button):hover .link__label {
    color: var(--nile-colors-primary-700, var(--ng-colors-text-brand-secondary-hover));
    text-decoration: var(--nile-text-decoration-none, var(--ng-text-decoration-underline));
  }

  .link:not(.link--disabled):not(.link__button):active,
  .link:not(.link--disabled):not(.link__button):active .link__label {
    color: var(--nile-colors-primary-900, var(--ng-colors-text-brand-secondary-hover));
  }

  .link__button:hover {
    color: var(--nile-colors-primary-700, var(--ng-colors-text-brand-tertiary-600));
    border-radius: var(--nile-radius-sm, var(--ng-radius-md));
    background: var(--nile-colors-dark-200, var(--ng-colors-bg-primary-hover));
  }

  .link__button.link--disabled .link__label {
    color: var(--nile-colors-primary-700, var(--ng-colors-fg-disabled));
  }

  .link__button.link--disabled:hover,
  .link__button.link--disabled:focus {
    color: var(--nile-colors-primary-500, var(--ng-colors-fg-disabled));
    box-shadow: var(--nile-box-shadow-none, var(--ng-shadow-none));
    border-radius: var(--nile-radius-sm, var(--ng-radius-md));
    background: var(--nile-colors-dark-200, var(--ng-colors-bg-primary));
  }

  .link__button:active {
    color: var(--nile-colors-primary-100, var(--ng-colors-text-brand-tertiary-600));
    border-radius: var(--nile-radius-sm, var(--ng-radius-md));
    background: var(--nile-colors-primary-100, var(--ng-colors-bg-primary));
    box-shadow: var(--nile-box-shadow-none, var(--ng-focus-ring));
  }

  .link__button:focus {
    border-radius: var(--nile-radius-sm, var(--ng-radius-md));
    box-shadow: var(--nile-box-shadow-none, var(--ng-focus-ring));
  }

`;

export default [styles];
